module.exports = __webpack_public_path__ + "static/carousel-8-21-9d1cbf0a1c69e60ad68b1c8e666b13a1.png";